import { IRootState } from '../../../store'
import { INarrativeState } from '../store/narrative.types'

export const getNarrativeSelector = (state: IRootState): INarrativeState => state.narrative
